import { createContext, useContext, useEffect, useState } from "react";
import { useServer } from "./ServerContext";
import { menuEndpoints } from "../env";

const MenuContext = createContext(undefined);

export const MenuProvider = ({children}) => {
    //HOOKS
    const { getRequest } = useServer();

    //STATES
    const [menu, setMenu] = useState(null);
    const [productsPool, setProductsPool] = useState([]);
    const [sectionPool, setSectionPool] = useState([]);

    //FUNCTIONS
    const loadMenu = () => {
        getRequest(menuEndpoints.get_menu, {id: document.settings.menu}, (res) => {
            if (res[0])
            {
                res = res[1];
                setMenu(res.menu);
            }
        });
    }

    //EFFECTS
    useEffect(() => {
        loadMenu();
    }, []);

    useEffect(() => {
        if (menu !== null)
        {
            let products = [];
            let sections = [];

            menu.sections.forEach((section) => {
                sections.push(section);

                section.products.forEach((product) => {
                    products.push(product);
                });
            });

            setProductsPool(products);
            setSectionPool(sections);
        }
    }, [menu]);

    const value = {
        menu,
        loadMenu,
        sectionPool,
    }

    return (
        <MenuContext.Provider value={value}>
            {children}
        </MenuContext.Provider>
    );
}

export const useMenu = () => useContext(MenuContext);